/* eslint-disable max-len */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import ModernDatepicker from 'react-modern-datepicker/build/components/ModernDatepicker';
import ReactStars from 'react-rating-stars-component';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

class PurchasesFeedbackRatingsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      rating: 0,
    };

    this.reactStarRef = React.createRef();
  }

  componentDidMount = () => {
    const { startDate, endDate } = this.state;
    this.setState({ rating: this.filterByDate(this.props.items, startDate, endDate) });
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { startDate, endDate } = this.state;
    if (prevState.startDate !== startDate || prevState.endDate !== endDate) {
      this.setState({ rating: this.filterByDate(this.props.items, startDate, endDate) });
    }
  }

  closeModal = () => this.props.closeModal();

  filterByDate = (items = [], startDate = null, endDate = null) => {
    let itensSum = 0;
    let itensFiltred = 0;
    let datePtbr = null;
    let startDateParsed = null;
    let endDateParsed = null;

    if (startDate) {
      datePtbr = startDate.split('/');
      startDateParsed = new Date(datePtbr[2], (+datePtbr[1]) - 1, datePtbr[0]);
    }
    if (endDate) {
      datePtbr = endDate.split('/');
      endDateParsed = new Date(datePtbr[2], (+datePtbr[1]) - 1, datePtbr[0]);
    }

    items.forEach((it) => {
      const dateTime = new Date(new Date(it.createdAt).toDateString()).getTime();
      let filtred = true;

      if (startDate) filtred = filtred && dateTime >= startDateParsed.getTime();
      if (endDate) filtred = filtred && dateTime <= endDateParsed.getTime();

      if (filtred) {
        itensSum += (it.websiteReviewScore || 0);
        itensFiltred += 1;
      }
    });

    return Math.trunc((itensSum / (itensFiltred || 1)) * 100) / 100;
  }

  onChangeStartDate = date => this.setState({ startDate: date })

  onChangeEndDate = date => this.setState({ endDate: date })

  cleanDate = () => this.setState({ startDate: null, endDate: null })

  render() {
    const { startDate, endDate, rating } = this.state;

    return (
      <div className="row justify-content-center" style={{ height: 'inherit' }}>
        <div className="orders-modal-main-feedback">
          <div>
            <span className="title-order-details">
              {I18n.t('feedbackMedianRating')}
            </span>
            <div className="row p-t-20 d-flex">
              <div className="col-1-5">
                <ModernDatepicker
                  lang="pt"
                  date={startDate}
                  format="DD/MM/YYYY"
                  showBorder
                  onChange={date => this.onChangeStartDate(date)}
                  placeholder={I18n.t('initDate')}
                  className="form-control"
                />
              </div>
              <div className="col-1-5">
                <ModernDatepicker
                  lang="pt"
                  date={endDate}
                  format="DD/MM/YYYY"
                  showBorder
                  onChange={date => this.onChangeEndDate(date)}
                  placeholder={I18n.t('finDate')}
                  className="form-control"
                />
              </div>
              <button
                onClick={() => this.cleanDate()}
                type="button"
                className="btn btn-secondary mr-1"
              >
                {I18n.t('clean')}
              </button>
            </div>
            <div className="feedback-score">
              <span style={{ paddingRight: '10px', paddingTop: '4px' }}>
                <strong>{I18n.t('userFeedbackScore')}</strong>
              </span>

              <ReactStars
                key={`star${rating}`}
                count={5}
                size={28}
                isHalf
                edit={false}
                activeColor="#ffd700"
                value={rating}
              />

              <span style={{ paddingLeft: '12px', paddingTop: '4px' }}>
                <strong>{`${rating}`.replace('.', ',')}</strong>
              </span>
            </div>
          </div>
          <div className="feedback-button-close">
            <button
              type="button"
              className="btn btn-danger"
              onClick={this.closeModal}
            >
              {I18n.t('close')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PurchasesFeedbackRatingsComponent);
